import { render, staticRenderFns } from "./InheritedDataFieldOption.vue?vue&type=template&id=23c181b7&"
import script from "./InheritedDataFieldOption.vue?vue&type=script&lang=js&"
export * from "./InheritedDataFieldOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCheckbox});
